import { VueRecaptcha } from 'vue-recaptcha';
import axios from '../../api/common/axios';

export default {
  name: 'signupForm',
  components: {
    'vue-recaptcha': VueRecaptcha
  },
  data() {
    return {
      isLoading: false,
      isSmartPhone: window.tom.user.isSmartPhoneDevice,
      name: '',
      email: '',
      password: '',
      flashMessage: {
        type: 'danger',
        body: window.options.signupErrorMsg
      },
      errorMessages: {
        email: '',
        password: ''
      },
      subscribe: true,
      form: window.options.form,
      redirect: window.options.redirect,
      isSignupError: window.options.isSignupError,
      type: window.options.type,
      code: window.options.code,
      iv: window.options.iv,
      invitationToken: window.options.invitationToken,
      accept: false
    };
  },
  computed: {
    loginUrl() {
      return '/login' + window.location.search;
    },
    isInvite() {
      return this.form === 'invite';
    }
  },
  methods: {
    getUrl(url) {
      let params = [`subscribe=${this.subscribe}`];
      if (this.redirect && this.redirect !== '/') {
        params.push('r=' + encodeURIComponent(this.redirect));
      }

      if (this.isSignupError) {
        return 'javascript:void(0);';
      } else if (params.length > 0) {
        return `${url}?${params.join('&')}`;
      }

      return url;
    },
    resetErrorMessages() {
      this.errorMessages.email = '';
      this.errorMessages.password = '';
      this.flashMessage.body = '';
    },
    submit() {
      window.tom.helper.ga.push([
        'event',
        'EmailSignUp',
        'Clicked',
        'Button',
        1
      ]);

      this.isLoading = true;
      this.$refs.recaptcha.execute();
    },
    onCaptchaVerified(recaptchaToken) {
      this.resetErrorMessages();
      this.$refs.recaptcha.reset();

      const postURL = this.isInvite ? '/invite/signup' : '/signup/regist';
      const data = {
        email: this.email,
        password: this.password,
        subscribe: this.subscribe,
        redirect: this.redirect,
        type: this.type,
        'g-recaptcha-response': recaptchaToken
      };
      if (this.isInvite) {
        data.code = this.code;
        data.iv = this.iv;
        data.invitationToken = this.invitationToken;
      }

      axios
        .post(postURL, data)
        .then((response) => {
          if (response.data.errors) {
            this.isLoading = false;
            if (response.data.errors.common) {
              this.flashMessage.body = response.data.errors.common.msg;
            }
            if (response.data.errors.email) {
              this.errorMessages.email = response.data.errors.email.msg;
            }
            if (response.data.errors.password) {
              this.errorMessages.password = response.data.errors.password.msg;
            }
            return;
          }

          // ラベルフォロー処理
          if (window.options.followLabelId) {
            this.$store
              .dispatch('labels/follow', window.options.followLabelId)
              .then(() => {
                this.$emit('registered', response.data.redirect);
              });
          } else {
            this.$emit('registered', response.data.redirect);
            //window.location.href = response.data.redirect;
          }
        })
        .catch((err) => {
          this.isLoading = false;

          const errData = err.response.data;
          this.flashMessage.type = 'danger';
          this.flashMessage.body =
            errData.err.common ||
            'An error occurred. Please wait a moment before trying again.';
        });
    },
    onCaptchaExpired() {
      this.isLoading = false;
      this.$refs.recaptcha.reset();
    },
    onCaptchaError() {
      this.isLoading = false;
      this.flashMessage.type = 'danger';
      this.flashMessage.body =
        'An error occurred. Please wait a moment before trying again.';
    }
  }
};
